module.exports = __webpack_public_path__ + "static/media/English_US_Britney BG-45.cb5b873d.png";